define('modules/page_listing/models/page',['require','exports','module','backbone','../collections/tags','../models/tag','lib/util','env'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
      TagCollection = require('../collections/tags'),
      Tag = require('../models/tag'),
      util = require('lib/util'),
      config = require('env');

  var Serialization = {
    parse: function (json) {
      this.tags.reset(json.tags || []);
      var pageJson = _.omit(json, ['tags']);
      return module.exports.__super__.parse.call(this, pageJson);
    },
    toJSON: function () {
      var originalJson = module.exports.__super__.toJSON.call(this);
      return _.extend(originalJson, {
        tags: this.tags.toJSON()
      });
    }
  };

  module.exports = Backbone.Model.extend({
    constructor: function () {
      this.tags = new TagCollection();
      module.exports.__super__.constructor.apply(this, arguments);
    },

    initialize: function () {
      this.listenTo(this.tags, 'add', _.bind(this.trigger, this, 'change:tags'));
      this.listenTo(this.tags, 'remove', this.removeTags);
    },

    url: function () {
      return [config.apiHost, 'pages', this.id ? this.id : this.platform].join('/');
    },

    publish: function (options) {
      options.error = _.compose(_.bind(this.set, this, 'published', false), options.error);
      this.save({published: true}, _.extend(options || {}, {patch: true, parse: false}));
    },

    unPublish: function (options) {
      options.error = _.compose(_.bind(this.set, this, 'published', true), options.error);
      this.save({published: false}, _.extend(options || {}, {patch: true, parse: false}));
    },

    toggleVisibility: function (options) {
      var hidden = this.get('hidden');
      options.error = _.compose(_.bind(this.set, this, 'hidden', hidden), options.error);
      this.save({hidden: !hidden}, _.extend(options || {}, {patch: true, parse: false}));
    },

    removeTags: function () {
      this.save({tags: this.tags.toJSON()}, {patch: true, success: _.bind(this.trigger, this, 'removed:tag')});
    },

    getCommonUrl: function () {
      return [config.apiHost, 'pages', this.id ? this.id : this.platform].join('/');
    },

    getCreateFromTemplateUrl: function (allplatforms) {
      var url = [config.apiHost, 'pages', this.platform, this.templateId].join('/');
      if (allplatforms) url += '?allplatforms=true';
      return url;
    },

    getUpdateUrl: function () {
      return [config.apiHost, 'pages', this.id, 'pub'].join('/');
    },

    getTagUrl: function () {
      return [config.apiHost, 'pages', this.id, 'tag'].join('/');
    }
  });

  util.mixin(module.exports, Serialization);
});

